import React from 'react';
import { toJS } from 'mobx';
import { inject, observer } from 'mobx-react';
import { toPairs } from 'ramda';

import { SectionLayout } from 'layouts/section';
import { Partner } from 'components/partner';

const styles = require('./partners-page.styles.scss');


@inject('configStore', 'analyticsStore', 'partnersStore')
@observer
export class PartnersPage extends React.Component {
  componentDidMount() {
    this.props.analyticsStore.pageview('/partners');
  }

  render() {
    const partnersSections = toPairs(toJS(this.props.partnersStore.partners$));

    return (
      <div className={styles.PartnersPage}>
        <SectionLayout>
          <h1>Partner</h1>
          {
            partnersSections.map(([section, partners]) => {
              return (
                <React.Fragment key={section}>
                  <h2>{ section }</h2>
                  {
                    partners.map((partner, idx) => <Partner key={idx} {...partner} />)
                  }
                </React.Fragment>
              )
            })
          }
        </SectionLayout>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/partners/partners.page.jsx